import { connect } from 'react-redux'
//import { state_update } from '../actions'
import AiReview from './AiReview'
import {DEFAULT_STATE_VALUE,ALL_STONES} from '../constants';
import {decodeHtml} from '../reducers/utils'
import getDescription2 from '../reducers/getDescription2'
import ReactGA from 'react-ga4';
const mapStateToProps = (state, ownProps) => ({
  gems: isGemExist(state),
  properties: getDescription(state),
 // options_all:state['options_all'],
  description:decodeHtml(state['description']),
  site:state['site'],
  version:state.version,
  showReview:state.showReview ? 'ai-show' : 'ai-hide',
  bolo:state['description'].toLowerCase().indexOf('bracelet') !==-1 &&(state['description'].toLowerCase().indexOf('bolo') ===-1 &&state['description'].toLowerCase().indexOf('adjust') ===-1 ) 
 
})
const isGemExist = (state)=>{
  for (let key in state['options_all'])
  {
   var keyValue=state['options_all'][key]
  if (ALL_STONES.indexOf(keyValue)  !== -1) {
    if (state[keyValue] !== DEFAULT_STATE_VALUE) {
     return true 
    }  
  }
 }
 return false
}

  
const getDescription = (state)=>{
  return getDescription2(state)
}


const mapDispatchToProps = (dispatch, ownProps) => ({
 
  onOpenReview: ( () => {
   // console.log('review event')
    ReactGA.event({
    category: 'Review',
    action:'Review'})}
    )
  /////onClick: ( () => dispatch(state_update({attr:'review',value:false})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiReview)


// WEBPACK FOOTER //
// ./src/layout/AiReviewWrap.js